export function ucwords(val) {
    let newVal = '';
    val = val.split(' ');
    for (let c = 0; c < val.length; c++) {
        newVal += val[c].substring(0, 1).toUpperCase() + val[c].substring(1, val[c].length) + (c + 1 === val.length ? '' : ' ');
    }
    return newVal;
}